import { render } from "./PreordersTable.vue?vue&type=template&id=fb9b3ede&scoped=true"
import script from "./PreordersTable.vue?vue&type=script&lang=js"
export * from "./PreordersTable.vue?vue&type=script&lang=js"

import "./PreordersTable.vue?vue&type=style&index=0&id=fb9b3ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9b3ede"]])

export default __exports__